module.exports = "<div class=\"form-control component-date-control\"> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition }} <p class=info>被修改条件限制</p> {{else}} <div class=date-control style=display:inline-block> <input type=text class=\"ui-calendar ui-width dynamic-form-input date_yy-mm-dd\" placeholder=年-月-日 value={{value}} /> </div> <span id=errorMessage></span> {{#if required}} <span id=requiredLogo class=\"{{requiredClass}} form-print-icon\" style=position:relative;left:-18px></span> {{/if}} {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/date-control/date-control.html
// module id = 1969
// module chunks = 50